import { io } from "socket.io-client";

const SOCKET_URL = process.env.REACT_APP_NOLA_BOT_URL;

let socket;

export const initiateSocket = async (properties) => {
  socket = io(SOCKET_URL, {
    path: "/ws-public/socket.io/",
    reconnectionDelayMax: 1800000, 
    transports: ["websocket"],
    auth: {
      ...properties,
    },
  });
  return socket;
};

export const disconnectSocket = () => {
  if (socket) socket.disconnect();
};

export const connectSocket = async () => {
  if (socket) {
    socket.connect();
  }
};

export const emitMessage = async (key, payload, callback) => {
  socket.emit(
    key,
    {
      ...payload,
    },
    (response) => {
      callback(response, payload.message, key);
    }
  );
};

export const subscribeToEvent = (eventKey, callback) => {
  if (socket) {
    socket.on(eventKey, callback);
  }
};

export const removeSubscription = (eventKey, callback) => {
  if (socket) {
    socket.off(eventKey, callback);
  }
};
